import { Route, Switch, useRouteMatch } from "react-router-dom";
import SettingsSitesList from "./sites/SettingsSitesList";
import SettingsSiteEditor from "./sites/SettingsSiteEditor";

const SettingsSites = ({ token, API }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <SettingsSitesList token={token} API={API} basePath={path} />
      </Route>
      <Route exact path={`${path}/new`}>
        <SettingsSiteEditor token={token} API={API} mode="create" />
      </Route>
      <Route path={`${path}/:id`}>
        <SettingsSiteEditor token={token} API={API} mode="edit" />
      </Route>
    </Switch>
  );
};

export default SettingsSites;
